import React from 'react';
import { useSelector } from 'react-redux';
import { SubmissionStatus } from '../../../../../redux/form/types';
import { getCurrentSubmission } from '../../../../../redux/form/selectors';
import PromptError from '../../partials/PromptError';

interface Props {
  className?: string;
}

const ErrorArea: React.FC<Props> = ({ className }) => {
  const currentSubmission = useSelector(getCurrentSubmission);

  return (
    <div aria-live="polite" className={className}>
      {currentSubmission.status === SubmissionStatus.Error && <PromptError />}
    </div>
  );
};

ErrorArea.displayName = 'ErrorArea';

export default ErrorArea;
